import { Injectable, signal } from "@angular/core"
import { Route, Routes } from '@angular/router'

@Injectable({ providedIn: "root" })
export class MenuStore {
    routeMenu = signal<any[]>([])

    #getRoute(routes: Routes, index: number) {

        const subroutes = routes.filter((x: Route) => {
            if (!x.component && !x.loadComponent)
                return false
            if (x.path === '401')
                return false
            if (index > 10 && `${x.path}` === '') {
                return false
            }

            return true
        }).map((x: Route) => {
            const routeData: any = x.data ?? {}
            const menuHeader: any = x.children ? this.#getRoute(x.children, index + 10) : null

            const entete = routeData['entete'] ?? null

            const sub = {
                id: index++,
                entete: entete,
                label: routeData['label'] ?? x.path,
                ...(routeData['icon'] && { icon: routeData['icon'] }),      // pas de propriété si pas d'icône
                url: x.path ? `${x.path}` : null,
                menuHeader: menuHeader
            }
            return sub
        })

        return subroutes
    }

    public initRoute = (routes: Routes) => {
        const subroutes = this.#getRoute(routes, 1)
        this.routeMenu.set(subroutes)
    }


    //isVisibleList(menuList, user) {
    //    return menuList.filter(menu => {
    //        let visible = true
    //        const roles: string[] = menu.roles
    //        if (roles) {
    //            visible = false
    //            roles.forEach(role => {
    //                if (user.roles.indexOf(role) > -1) {
    //                    visible = true
    //                }
    //            })
    //        }
    //        if (visible && menu.onglets) {
    //            const onglets = this.isVisibleList(menu.onglets, user)
    //            menu.onglets = onglets
    //        }
    //        return visible
    //    })
    //}



    //// Menu traduit et réactif
    //readonly menu = computed<MenuHeaderLead[]>(() => {
    //    return this.rawMenuSignal().map(this.mapLead)
    //});

    //private mapLead = (raw: any): MenuHeaderLead => {
    //    return new MenuHeaderLead(
    //        raw.id ?? null,
    //        this.translate.stream(raw.label), // Observable<string>
    //        raw.menuHeader?.map(this.mapHeader) ?? null
    //    )
    //};

    //private mapHeader = (raw: any): MenuHeader => {
    //    return new MenuHeader(
    //        raw.id ?? null,
    //        this.translate.stream(raw.label),
    //        raw.icon ?? null,
    //        raw.menuItem?.map(this.mapItem) ?? null
    //    )
    //};

    //private mapItem = (raw: any): MenuItem => {
    //    return new MenuItem(
    //        raw.id ?? null,
    //        this.translate.stream(raw.label),
    //        raw.url ?? null
    //    )
    //};

}
